(() => {
  const config = document.getElementById('ttp-vehicle-config');
  if (!config) return;
  const { text, models } = JSON.parse(config.textContent);
  let sequence = 0;
  const makes = Object.keys(models).sort();
  const years = Array.from({ length: new Date().getFullYear() + 2 - 1950 }, (_, i) => String(new Date().getFullYear() + 1 - i));
  const canonicalMake = value => makes.find(make => make.toLowerCase() === value.trim().toLowerCase());
  const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
  function suggestions(input, values) {
    input._vehicleValues = values;
    if (input._vehiclePopup) return;
    const wrap = document.createElement('span');
    wrap.className = 'ttp-vehicle-combobox';
    const popup = document.createElement('span');
    popup.className = 'ttp-vehicle-options';
    popup.id = 'ttp-vehicle-options-' + (++sequence);
    popup.setAttribute('role', 'listbox');
    const fieldLabel = input.labels?.[0]?.textContent.trim() || text.model;
    popup.setAttribute('aria-label', fieldLabel);
    input.setAttribute('aria-label', fieldLabel);
    popup.hidden = true;
    input.before(wrap);
    wrap.append(input, popup);
    input._vehiclePopup = popup;
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-controls', popup.id);
    input.setAttribute('aria-expanded', 'false');
    let active = -1;
    let matches = [];
    const close = () => {
      popup.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    };
    const choose = value => {
      input.value = value;
      close();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      close();
    };
    const show = () => {
      const query = normalize(input.value);
      matches = input._vehicleValues.filter(value => normalize(value).includes(query)).slice(0, 8);
      popup.replaceChildren();
      active = -1;
      matches.forEach((value, index) => {
        const option = document.createElement('span');
        option.id = popup.id + '-' + index;
        option.setAttribute('role', 'option');
        option.setAttribute('aria-selected', 'false');
        option.textContent = value;
        option.addEventListener('pointerdown', event => {
          event.preventDefault();
          event.stopPropagation();
          choose(value);
        });
        option.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          if (!popup.hidden) choose(value);
        });
        popup.append(option);
      });
      popup.hidden = !matches.length;
      input.setAttribute('aria-expanded', String(Boolean(matches.length)));
      input.removeAttribute('aria-activedescendant');
    };
    input.addEventListener('focus', show);
    input.addEventListener('input', show);
    input.addEventListener('blur', () => setTimeout(close, 120));
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape') { close(); return; }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (popup.hidden) show();
        if (!matches.length) return;
        active = (active + (event.key === 'ArrowDown' ? 1 : -1) + matches.length) % matches.length;
        [...popup.children].forEach((option, index) => option.setAttribute('aria-selected', String(index === active)));
        input.setAttribute('aria-activedescendant', popup.children[active].id);
        popup.children[active].scrollIntoView({ block: 'nearest' });
      } else if (event.key === 'Enter' && !popup.hidden && matches.length) {
        event.preventDefault();
        choose(matches[active >= 0 ? active : 0]);
      } else if (event.key === 'Tab') close();
    });
  }
  function clearAcknowledgment(form) {
    const check = form.querySelector('[name="properties[Fitment acknowledged]"]');
    if (check) check.checked = false;
  }
  function connect(make, model, year, form) {
    suggestions(make, makes);
    suggestions(year, years);
    make.placeholder = text.make_hint;
    model.placeholder = text.model_hint;
    function update(clear) {
      const key = canonicalMake(make.value);
      if (clear) model.value = '';
      suggestions(model, models[key] || []);
      clearAcknowledgment(form);
    }
    make.addEventListener('input', () => update(true));
    make.addEventListener('change', () => {
      const key = canonicalMake(make.value);
      if (key) make.value = key;
      update(false);
    });
    update(false);
  }
  function field(group, labelText, key, required) {
    const label = document.createElement('label');
    const input = document.createElement('input');
    input.type = 'text';
    input.id = 'ttp-vehicle-' + (++sequence) + '-' + key;
    input.dataset.vehicleField = key;
    input.required = required;
    input.maxLength = key === 'year' ? 4 : 100;
    if (key === 'year') { input.inputMode = 'numeric'; input.pattern = '[0-9]{4}'; }
    label.htmlFor = input.id;
    label.append(document.createTextNode(labelText + (required ? ' *' : '')), input);
    group.append(label);
    return input;
  }
  function combined(original) {
    if (original.dataset.vehicleEnhanced) return;
    const form = original.closest('form');
    const label = original.closest('label');
    if (!form || !label) return;
    original.dataset.vehicleEnhanced = 'true';
    label.classList.add('ttp-vehicle-original');
    const required = original.required;
    const group = document.createElement('fieldset');
    group.className = 'ttp-vehicle-selector sp-wide';
    const legend = document.createElement('legend');
    legend.textContent = text.heading;
    const grid = document.createElement('div');
    grid.className = 'ttp-vehicle-grid';
    const year = field(grid, text.year, 'year', required);
    const make = field(grid, text.make, 'make', required);
    const model = field(grid, text.model, 'model', required);
    const bed = field(grid, text.bed, 'bed', required);
    bed.placeholder = text.bed_hint;
    const hint = document.createElement('p');
    hint.className = 'ttp-vehicle-hint';
    hint.textContent = text.note;
    const summary = document.createElement('p');
    summary.className = 'ttp-vehicle-summary';
    summary.setAttribute('role', 'status');
    summary.setAttribute('aria-live', 'polite');
    summary.setAttribute('aria-atomic', 'true');
    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ttp-vehicle-manual';
    toggle.textContent = text.manual;
    let manual = Boolean(original.value.trim());
    function mode() {
      label.hidden = !manual;
      original.required = manual && required;
      original.type = manual ? 'text' : 'hidden';
      grid.hidden = manual;
      hint.hidden = manual;
      summary.hidden = manual;
      grid.querySelectorAll('input').forEach(input => { input.disabled = manual; });
      toggle.textContent = manual ? text.search : text.manual;
    }
    function sync() {
      if (manual) return;
      const parts = [year.value, make.value, model.value].map(v => v.trim()).filter(Boolean);
      const vehicle = parts.join(' ');
      original.value = vehicle + (bed.value.trim() ? ' | ' + text.bed + ': ' + bed.value.trim() : '');
      summary.textContent = original.value ? text.selected + ' ' + original.value : '';
      clearAcknowledgment(form);
    }
    group.append(legend, grid, hint, summary, toggle);
    label.before(group);
    connect(make, model, year, form);
    grid.addEventListener('input', sync);
    grid.addEventListener('change', sync);
    original.addEventListener('input', () => clearAcknowledgment(form));
    toggle.addEventListener('click', () => {
      manual = !manual;
      mode();
      if (manual) original.focus();
      else { sync(); make.focus(); }
      clearAcknowledgment(form);
    });
    form.addEventListener('reset', () => setTimeout(() => {
      manual = Boolean(original.defaultValue.trim());
      mode();
      suggestions(model, []);
      summary.textContent = '';
    }, 0));
    mode();
  }
  function separate(form) {
    const year = form.querySelector('[name="contact[truck_year]"], [name="contact[vehicle_year]"]');
    let make = form.querySelector('[name="contact[truck_make]"], [name="contact[vehicle_make]"]');
    const model = form.querySelector('[name="contact[truck_model]"], [name="contact[vehicle_model]"]');
    if (!year || !make || !model || make.dataset.vehicleEnhanced) return;
    if (make.tagName === 'SELECT') {
      const replacement = document.createElement('input');
      for (const attribute of make.attributes) replacement.setAttribute(attribute.name, attribute.value);
      replacement.value = make.value;
      replacement.type = 'text';
      make.replaceWith(replacement);
      make = replacement;
    }
    make.dataset.vehicleEnhanced = 'true';
    connect(make, model, year, form);
  }
  function init() {
    document.querySelectorAll('input').forEach(input => {
      const name = input.name;
      const label = input.closest('label')?.textContent || '';
      if (name === 'properties[Truck fitment]' || name === 'contact[truck_and_bed]' ||
          (name === 'contact[application]' && /year.*make.*model/i.test(label))) combined(input);
    });
    document.querySelectorAll('form').forEach(separate);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
